export default __webpack_public_path__ + "static/media/meal-ticket.56c6bdd6.png";